import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import { reduxForm, getFormValues, Field, reset, FieldArray } from 'redux-form'
import { Confirm, Modal, Button, Header } from 'semantic-ui-react'
import r from 'reactotron-react-js'
import ReactTable from 'react-table'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { Cont, ModalAction } from './styled'
import { columns } from '../../../AttributeData'
import {
  createUserDepartment,
  fetchUserDepartments,
  fetchDepartments,
  fetchUsersRole,
  fetchMainDepartments,
} from 'ducks/roleMan'

import { Toaster } from '@blueprintjs/core'
let toast = Toaster.create({ message: '', show: false })

const FormAdjustDepartmentUser = props => {
  const {
    handleSubmit,
    data,
    valueForm,
    show,
    title,
    changeShow,
    showConfirm,
    setShowConfirm,
    subDepartments,
    setSubDepartments,
    loading,
    subRequire,
    setSubRequire,
  } = props

  const onDataCreated = (pageSize, setCurrentPage) => itemCount => {
    r.log({ pageSize, setCurrentPage, itemCount })
    if (itemCount <= pageSize) {
      setCurrentPage(0)
    } else {
      let targetPage = Math.ceil(itemCount / pageSize)
      setCurrentPage(targetPage - 1)
    }
  }
  return (
    <div>
      <Modal
        size="tiny"
        open={show}
        closeOnEscape={false}
        closeOnDimmerClick={false}
        // onMount={() => onModalMount()}
        style={{ zIndex: 20 }}
      >
        <Modal.Header>{title || ''}</Modal.Header>
        <Modal.Content>
          <form
            onSubmit={handleSubmit(() => {
              let subDept = Object.keys(valueForm)
              let isCheck = subDept.filter(id => valueForm[id] === true)
              if (isCheck.length === 0) {
                props.setSubRequire('Required!')
                return
              } else {
                props.setSubRequire('')
                setShowConfirm(true)
              }
            })}
          >
            <Cont>
              <React.Fragment>
                <Field
                  name="username"
                  label="User Name"
                  options={props.usersRole}
                  loading={loading}
                  type={type.select}
                  component={FieldInput}
                  require
                  placeHolder={'Select User Name'}
                />
                <Field
                  name="mainDept"
                  label="Main Dept"
                  options={props.mainDepartments}
                  loading={loading}
                  type={type.select}
                  component={FieldInput}
                  onChange={value => {
                    if(valueForm.items){
                      Object.keys(valueForm.items).forEach(id => { delete valueForm.items[id] })
                    }
                    let filterSub = props.departments.filter(
                      item =>
                        item.mainDepartmentCode === value &&
                        item.subDepartmentCode != ''
                    )
                    setSubDepartments(filterSub)
                    filterSub.forEach(item => {props.change(`items.${item.subDepartmentCode}`, false)})
                    props.change('Select', false)
                  }}
                  require
                  placeHolder={'Select Main Department'}
                />
              </React.Fragment>
              <div style={{ height: '20px', color: 'red' }}>
                {props.subRequire}
              </div>
              <div className="subCont ui form">
                <ReactTable
                  data={props.subDepartments && props.subDepartments}
                  columns={columns.tDepartment}
                  defaultPageSize={5}
                  previousText="previous"
                  nextText="next"
                  showPageJump={false}
                  showPageSizeOptions={false}
                  className="-striped -highlight"
                  getTdProps={(state, rowInfo, column, instance) => {
                    return {
                      onClick: (e, value) => {
                        if (e.target.nodeName === 'LABEL') {
                          props.setSubRequire('')
                          if (valueForm.items) {
                            let all = true
                            Object.keys(valueForm.items).forEach(id => {
                              if(rowInfo.original.subDepartmentCode === id){
                                all = all && !valueForm.items[id]
                              }else{
                                all = all && valueForm.items[id]
                              }
                            })
                            props.change('Select', all)
                          }
                        }
                      },
                    }
                  }}
                  getTheadThProps={column => {
                    return {
                      onClick: e => {
                        if (e.target.nodeName === 'LABEL') {
                          props.setSubRequire('')
                          props.subDepartments.forEach(item => {
                            props.change(
                              `items.${item.subDepartmentCode}`,
                              !props.valueForm.Select
                            )
                          })
                        }
                      },
                    }
                  }}
                />
              </div>
            </Cont>
            <ModalAction>
              {!props.isCreate && (
                <Button
                  onClick={() => props.setIsDelete(true)}
                  type="submit"
                  negative
                >
                  Delete
                </Button>
              )}
              <Button onClick={() => closeModal()} negative>
                Cancel
              </Button>
              <Button
                onClick={() => {
                  props.setIsDelete(false)
                }}
                type="submit"
                positive
                labelPosition="right"
                icon="save"
                content="Save"
              />
            </ModalAction>
          </form>
        </Modal.Content>
      </Modal>
      <Confirm
        size="mini"
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={() => submitModal()}
      />
    </div>
  )

  function submitModal() {
    setShowConfirm(false)
    let subDept = Object.keys(valueForm.items)
    let isCheck = subDept.filter(
      id => valueForm.items[id] === true && id !== 'Select'
    )
    if (props.isCreate) {
      let user = props.userDepartments.find(
        item => item.username === valueForm.username
      )
      let createUserDept
      if (user) {
        let duplicate,
          addSub = []
        let hasSubDept = isCheck.forEach(sub => {
          let t = user.items.find(item => item.subDepartment === sub)
          if (t) {
            duplicate = 'Sub Department was already'
          } else {
            addSub.push(sub)
          }
        })
        if (duplicate) {
          toast.clear()
          toast.show({
            message: duplicate,
            intent: 'warning',
            timeout: 5000,
          })
        }
        if (addSub.length) {
          createUserDept = addSub.map(item => ({
            username: valueForm.username,
            mainDepartment: valueForm.mainDept,
            subDepartment: item,
            createdBy: null,
          }))
          props.createUserDepartment(
            createUserDept,
            closeModal,
            onDataCreated(props.tablePageSize, props.setCurrentPage)
          )
        }
        closeModal()
      } else {
        createUserDept = isCheck.map(item => ({
          username: valueForm.username,
          mainDepartment: valueForm.mainDept,
          subDepartment: item,
          createdBy: null,
        }))
        props.createUserDepartment(
          createUserDept,
          closeModal,
          onDataCreated(props.tablePageSize, props.setCurrentPage)
        )
      }
    }
  }

  function closeModal() {
    changeShow()
    props.dispatch(reset('formAdjustDepartmentUser'))
  }

  function onModalMount() {
    props.fetchDepartments()
    props.fetchUsersRole()
    props.fetchMainDepartments()
    if (data) {
      setSubDepartments(
        props.departments.filter(
          item => item.mainDepartmentCode === data.mainDepartment
        )
      )
    } else {
      setSubDepartments([])
    }
  }
}

const validate = (values, props, state) => {
  const errors = {}
  if (!values.username) {
    errors.username = 'Required!'
  }
  if (!values.mainDept) {
    errors.mainDept = 'Required!'
  }
  return errors
}

const mapStateToProps = (state, props) => {
  return {
    initialValues: {},
    valueForm: getFormValues('formAdjustDepartmentUser')(state),
    usersRole: state.roleMan.usersRole
      ? state.roleMan.usersRole.map(item => ({
          value: item.username,
          text: item.fullName,
        }))
      : [],
    mainDepts: props.data
      ? state.roleMan.departments.filter(
          item =>
            item.mainDepartmentCode === props.data.mainDepartment &&
            item.subDepartmentCode
        )
      : [],
    departments: state.roleMan.departments,
    mainDepartments: state.roleMan.mainDepartments
      ? state.roleMan.mainDepartments.map(item => ({
          value: item.departmentCode,
          text: item.departmentName,
        }))
      : [],
    userDepartments: state.roleMan.userDepartments,
    loading: state.roleMan.loading,
  }
}

const mapDispatchToProps = {
  createUserDepartment,
  fetchUserDepartments,
  fetchDepartments,
  fetchUsersRole,
  fetchMainDepartments,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'formAdjustDepartmentUser',
    validate: validate,
    enableReinitialize: true,
  }),
  withState('showConfirm', 'setShowConfirm', false),
  withState('isDelete', 'setIsDelete', false),
  withState('subDepartments', 'setSubDepartments', []),
  withState('subRequire', 'setSubRequire'),
  lifecycle({
    componentDidMount() {
      this.props.fetchDepartments()
      this.props.fetchUsersRole()
      this.props.fetchMainDepartments()
    },
    componentWillReceiveProps(nextProp) {},
  })
)

export default enhance(FormAdjustDepartmentUser)
